/* @flow */
// typecheck: ignore file
import React from 'react';
import ReactDOM, { unstable_renderSubtreeIntoContainer as renderSubtreeIntoContainer } from 'react-dom'; // eslint-disable-line camelcase

import ModalPrefetcher from 'components/ModalPrefetcher.jsx';

/* Note: This is used to ensure that modals are removed and displayed in the correct order. This is
 * done at the end of event loops to prevent events (like clicks) from being triggered on elements
 * that were already removed from the DOM.
 */
const _queue = [];
function queue(fn: Function) {
  _queue.push(fn);
  if (_queue.length === 1) {
    setTimeout(() => {
      _queue.forEach(f => f());
      _queue.length = 0;
    }, 0);
  }
}

/**
 * Mount a modal in the DOM.
 *
 * @param {React component} modal
 * @param {React component} parent, the modal will inherit its context
 * @return Function to unmount this modal
 */
export function mountModal(modal: React$Element<*>, parent: React$Component<*, *, *>): Function {
  const container = document.createElement('div');
  document.body.appendChild(container);

  const unmountNode = () => queue(() => ReactDOM.unmountComponentAtNode(container));

  renderSubtreeIntoContainer(
    parent,
    <ModalPrefetcher onRequestHide={unmountNode} modal={modal} />,
    container
  );

  return unmountNode;
}



// WEBPACK FOOTER //
// ./src/lib/modal.js